import * as Yup from 'yup';

const getValidationSchema = () =>
  Yup.object({
    message: Yup.string().required('Required')
  });

export const validationSchema = getValidationSchema();

export type FormValues = Yup.InferType<typeof validationSchema>;
